import {
  BankContact,
  BankDossier,
} from '../../../../api/workOrders/bankDossier';
import { Constants } from '../../../../constants/bankDossier';
import { phoneOrEmpty, textOrEmpty } from '../../../../helpers/bankDossier';
import { DossierColumn, DossierTable } from '../../DossierTable';
import { BodyCell, CellSecondary, MutedCell } from '../../DossierTable/styles';

interface SectionProps {
  dossier: BankDossier;
}

const { columns } = Constants.contacts;

const contactColumns: DossierColumn[] = [
  { key: 'type', label: columns.type },
  { key: 'name', label: columns.fullName },
  { key: 'organization', label: columns.organization },
  { key: 'code', label: columns.code },
  { key: 'email', label: columns.email },
  { key: 'business', label: columns.businessPhone },
  { key: 'home', label: columns.homePhone },
  { key: 'mobile', label: columns.mobilePhone },
  { key: 'fax', label: columns.fax },
];

export function ContactsSection({ dossier }: SectionProps): JSX.Element {
  const renderRow = (row: BankContact): JSX.Element => (
    <>
      <BodyCell>{row.contact_type}</BodyCell>
      <BodyCell>{row.full_name}</BodyCell>
      <MutedCell>{textOrEmpty(row.organization)}</MutedCell>
      <MutedCell>{textOrEmpty(row.contact_code)}</MutedCell>
      <BodyCell>{textOrEmpty(row.email)}</BodyCell>
      <BodyCell sx={{ whiteSpace: 'nowrap' }}>
        {phoneOrEmpty(row.business_phone)}
        {row.extension && (
          <CellSecondary>
            {columns.extension} {row.extension}
          </CellSecondary>
        )}
      </BodyCell>
      <BodyCell sx={{ whiteSpace: 'nowrap' }}>
        {phoneOrEmpty(row.home_phone)}
      </BodyCell>
      <BodyCell sx={{ whiteSpace: 'nowrap' }}>
        {phoneOrEmpty(row.mobile_phone)}
      </BodyCell>
      <MutedCell sx={{ whiteSpace: 'nowrap' }}>
        {phoneOrEmpty(row.fax)}
      </MutedCell>
    </>
  );

  return (
    <DossierTable<BankContact>
      columns={contactColumns}
      rows={dossier.contacts}
      getRowId={(row) => row.id}
      renderRow={renderRow}
      emptyMessage={Constants.contacts.empty}
      ariaLabel={Constants.sections.contacts}
    />
  );
}
